import { Container, Card, Row, Col } from "react-bootstrap";

const SponsorsList = () => {
    const sponsors = [
        {
            name: "International Foods",
            logo: "https://assets.cdn.filesafe.space/dyZhyOKWZZDxnj6GwLCP/media/66ce83d895f57a48716fc77e.png",
            description: "Halal grocery store",
            contribution:
                "International Foods is our most generous sponsor. They support the community by donating zakat annually and providing food assistance. We are grateful to partner with them to refer individuals and families in need.",
            url: "https://ifatx.com/"
        },
        {
            name: "Zaviya Grill",
            logo: "https://static.spotapps.co/website_images/ab_websites/67749_website/logo.png",
            description: "Halal Pakistani/Indian restaurant",
            contribution:
                "Zaviya Grill generously provides their space at no cost for our programs. The owners are consistent contributors of zakat and active supporters of our mission.",
            url: "https://www.zaviyagrill.com/"
        },
        {
            name: "IndoPak",
            logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTZhp5-4fWKVjZVssjc_2my3A-RaDPgq1aVMg&s",
            description: "Halal grocery store",
            contribution:
                "IndoPak donates fresh meat and groceries regularly, and allows those in need to shop at little to no cost. Their continued support has made a meaningful difference for many families.",
            url: "https://www.facebook.com/IndoPakrr/"
        }
    ];

    return (
        <Container className="mt-4 px-4 mb-4">
            <Row className="justify-content-center">
                {sponsors.map((s, idx) => (
                    <Col md={4} sm={6} xs={12} key={idx} className="mb-4">
                        <Card className="h-100 text-center p-3 sponsor-card d-flex flex-column" style={{ borderColor: "#336633" }}>
                            <img
                                src={s.logo}
                                alt={`${s.name} logo`}
                                style={{ maxWidth: "80%", height: "70px", margin: "0 auto 1rem" }}
                            />
                            <Card.Body className="d-flex flex-column justify-content-between">
                                <div>
                                    <Card.Title style={{ color: "#336633", fontSize: "1.3rem", marginBottom: ".5rem" }}>
                                        {s.name}
                                    </Card.Title>
                                    <Card.Text style={{ fontSize: "1rem", textAlign: "left" }}>
                                        <div className="text-center">{s.description}</div>
                                        <br />
                                        <strong>Their contribution:</strong> {s.contribution}
                                    </Card.Text>
                                </div>
                                <a
                                    href={s.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn mt-3"
                                    style={{ backgroundColor: "#336633", color: "#fff", border: "none" }}
                                >
                                    Visit site →
                                </a>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default SponsorsList;
